import { mask } from 'vue-the-mask'

// eslint-disable-next-line no-unused-vars
export default {
      directives: {
        mask
      },
    data () {
      return {
        validationRules: {
          required: v => !!v || 'Es necesario completar este campo',
          requiredBoolean: v => !(!v && v!==false) || 'Es necesario completar este campo',
          maxLength(v, maximum) { return (v || '').length <= maximum || 'El campo excede la longitud máxima permitida (' + maximum + ' caracteres)'; },
          rangeInt(v, minimum, maximum) { return ((v || '') >= minimum && (v || '') <= maximum) || 'El campo está fuera del rango permitido [ ' + minimum + ' - ' + maximum + ' ]'; },
          email: v => !v || /.+@.+\..+/.test(v) || 'No es un e-mail válido',
          dni: v =>  !v || this.validateDNI(v) || 'No es un DNI/NIE válido',
          cif: v => this.validateCIF(v) || 'No es un CIF válido',
          dnicif: v => !v || this.validateDNI(v) || this.validateCIF(v) || 'No es un NIF/CIF válido',
          iban: v => /^([a-zA-Z]{2})\s*\t*(\d{2})\s*\t*(\d{4})\s*\t*(\d{4})\s*\t*(\d{2})\s*\t*(\d{10})$/.test(v) || 'No es un IBAN válido',
          phone: v => !v || /^[0-9]{9}$/.test(v) || 'No es un teléfono válido',
          nass: v => this.validateNASS(v) || 'No es un NAF válido',
          date: v => !v || this.validateDate(v) || 'No es una fecha válida dd/mm/aaaa',
          codigoFirma: v => /^[0-9]{5}$/.test(v) || 'No es un código válido',
          pastDate: v => !v || this.validatePastDate(v) || 'La fecha no puede ser superior al día de hoy',
          notBeforeDate (vm, before) { return v => !v || vm.validateNotBeforeDate(before, v) || 'La fecha no puede ser anterior a ' + before; },
        },
      }
    },
    methods: {
      validateNotBeforeDate (before, value) {
        value = this.fixIEDate(value);
        var beforeDate = this.parseLocalDate(before);

        if (value === undefined || value == null || value.length != 10) {
          return false;
        }

        var esValido = this.parseLocalDate(value);
        if (esValido.getTime()!==esValido.getTime())
            return false;

        return (esValido.getTime()>=beforeDate.getTime());
      },
      validatePastDate (value) {

        value = this.fixIEDate(value);

        if (value === undefined || value == null || value.length != 10) {
          return false;
        }

        var esValido = this.parseLocalDateTime(value);
        if (esValido.getTime()!==esValido.getTime())
            return false;

        var now = new Date().getTime();

        return (esValido.getTime()<now);
      },
      validateDate (value) {

        value = this.fixIEDate(value);

        if (value === undefined || value == null || value.length != 10) {
          return false;
        }

        var esValido = this.parseLocalDate(value);
        return esValido.getTime()===esValido.getTime();
      },
      fixIEDate(ieDate) {
          if (!ieDate || ieDate.length!=15) return ieDate;
          var actual = ieDate.replace(/\D/g,'');
          return actual.substring(0,2) + "/" + actual.substring(2,4) + "/" + actual.substring(4);
      },
      validateDNI (value) {
        value = value ? value.toUpperCase() : null;

        var esValido = /^([0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]|[XYZ]{1}[0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET])$/.test(value);

        if (esValido === false) {
            return false;
        }

        var letrasValidas = "TRWAGMYFPDXBNJZSQVHLCKET";

        var nie = value.replace(/^[X]/, '0').replace(/^[Y]/, '1').replace(/^[Z]/, '2');

        var letra1 = value.substr(-1);
        var posicion = parseInt(nie.substr(0, 8)) % 23;
        var letra2 = letrasValidas.charAt(posicion);

        return letra1 === letra2;
    },
    validateCIF (value) {
      value = value ? value.toUpperCase() : null;

      var esValido = /^[A-Z]{1}[0-9]{7}[A-J0-9]{1}$/.test(value);

      if (esValido === false) {
          return false;
      }

      var letrasValidas = "JABCDEFGHI";

      var digitos = value.substr(1, value.length - 2);
      var letra = value.substr(0, 1);
      var control = value.substr(value.length - 1);
      var suma = 0;

      if (!letra.match(/[A-Z]/)) {
        return false;
      }

      for (var i = 0; i < digitos.length; i++) {
        var digito = parseInt(digitos[i]);

        if (isNaN(digito)) {
          return false;
        }

        if (i % 2 === 0) {
          digito *= 2;
          if (digito > 9) {
            digito = parseInt(digito / 10) + (digito % 10);
          }

          suma += digito;
        } else {
          suma += digito;
        }
      }

      suma %= 10;
      if (suma !== 0) {
        digito = 10 - suma;
      } else {
        digito = suma;
      }

      if (letra.match(/[ABEH]/)) {
        return String(digito) === control;
      }
      if (letra.match(/[NPQRSW]/)) {
        return letrasValidas[digito] === control;
      }

      return String(digito) === control || letrasValidas[digito] === control;
    },
    validateNASS (value) {
      value = value ? value.replace(/[^0-9]/g, '') : null;

      var esValido = /^[0-9]{12}$/.test(value);

      if (esValido === false) {
        return false;
      }

      var a = value.substring(0, 2);
      var b = value.substring(2, 8);
      var c = value.substring(8);
      var d;

      if (b < 10000000) {
        d = b + a * 10000000;
      } else {
        d = a.concat(b);
      }

      return d % 97 !== c;
    },
    formatLocalDate (date) {
        if (!date) return null

        if (typeof date === 'number')
            date = new Date(date); //la entrada son milisegundos

        if (typeof date === 'string') {
					if (date.split('-') < 6) date + "T00:00:00";
            var parts = date.match(/(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/);
            date = new Date(parts[1], parts[2]-1, parts[3], parts[4], parts[5], parts[6]);
        }      

        return date.toLocaleDateString('es-ES', { year: 'numeric', month: '2-digit', day: '2-digit' });
    },
    formatLocalDateTime (date) {
        if (!date) return null

        if (typeof date === 'number')
            date = new Date(date); //la entrada son milisegundos

        if (typeof date === 'string') {
            var parts = date.match(/(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/);
            date = new Date(parts[1], parts[2]-1, parts[3], parts[4], parts[5], parts[6]);
        }

        return date.toLocaleDateString('es-ES', { year: 'numeric', month: '2-digit', day: '2-digit' })+ ' ' 
					+ date.toLocaleTimeString(['es-ES'], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    },
      formatISODate (date) {
        if (!date) return null

        if (typeof date === 'number')
          date=new Date(date); //la entrada son milisegundos

        return date.toISOString().substring(0, 10);
      },
      parseLocalDate (date) {
        if (!date) return null

        if (typeof date === 'number')
          return new Date(date); //la entrada son milisegundos

        var parts = date.split('/')

        if (parts.length!=3) return date;

        return new Date(`${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`);
      },
      parseLocalDateTime (date) {
        if (!date) return null

        if (typeof date === 'number')
          return new Date(date); //la entrada son milisegundos

        var parts = date.split('/')

        if (parts.length!=3) return date;

        return new Date(`${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}T00:00:00`);
      },
      parseISODate (date) {
        if (!date) return null

        const [year , month, day ] = date.split('-')

        return new Date(`${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`)
      },
      processValidationErrors: function (refs, violations, msgCb) {
        if (!violations) {
          return;
        }

        var firstElement=null;

        for (var pos = 0; pos < violations.length; pos++) {
          var v = violations[pos];
          var element = refs[v.propertyPath];

          if (element) {
            if (firstElement==null)
              firstElement = element;

            element.restValidationError = true;
            element.attrs$['restValidationError']=true;
            element.errorMessages.push(v.message);
          }
          else {
            if (msgCb)
                msgCb({ color: 'error', text: v.message });
            else
              this.$emit('alert-event', { text: v.message, type: 'error' });
            break;
          }


        }

        if (firstElement!=null)
            firstElement.$el.scrollIntoView();
      },
      // eslint-disable-next-line no-unused-vars
      clearRestValidationError: function (element, event) {
        if (element.restValidationError === true) {
          element.restValidationError = false;
          element.errorMessages.pop();
        }
      },
      scrollToFirstError: function (form) {

        try {

          if (!form) return;

          var children = form.inputs;

          if (!children) return;

            for (var p=0; p<children.length;p++)
              if (children[p].valid===false)
              {
                children[p].$el.scrollIntoView();
                break;
              }
        } catch (e) { console.log(e);}
      },
      padNif: function (nif)
      {
        if (!nif || nif.length!=9) return nif;

        return '0'+nif;
      }
      ,
      trimNif: function (nif)
      {
        if (!nif || nif.length!=10) return nif;

        return nif.substring(1);
      }
    }
}